import { HomepageSettingsFactory } from './homepageSettingsFactory';

import type {
  HomepageSettingsEntity,
  HomepageSettingsProps,
} from './homepageSettingsEntity';
import type { HomepageSettingsIRepository } from './homepageSettingsIRepository';
import type { EntityDataType } from '@/infra/appsync';
import type { HomepageSettingsJson } from '@/types/domain/childApply/entities/homepageSettingsEntity';

import { AppsyncRepositoryPvt } from '@/domain/appsyncRepositoryPvt';
import { EntityName } from '@/infra/appsync';

/**
 * ホームページ設定レポジトリ
 */
export class HomepageSettingsRepository extends AppsyncRepositoryPvt<
  HomepageSettingsEntity,
  HomepageSettingsProps,
  HomepageSettingsJson
> implements HomepageSettingsIRepository {
  private factory = new HomepageSettingsFactory();

  protected get entityName(): EntityName {
    return EntityName.WagakoNurseryHomepageSettingsEntity;
  }

  protected createFromEntityDataType = (
    props: EntityDataType,
  ) => this.factory.createFromEntityDataType(props);
}
